import videojs from "video.js";
import getCameraIcon from "../templates/camera.svg.html";

class SwitchButton extends videojs.getComponent('ClickableComponent') {
	constructor(player, options) {
		super(player, options);
		this.activeClassName = `${this.options().className}_active`;
		this.$('.vjs-icon-placeholder').innerHTML = getCameraIcon({
			width: 24,
			height: 24,
			type: this.options_.iconType
		})
	}

	turnOn() {
		this.addClass(this.activeClassName);
	}

	turnOff() {
		this.removeClass(this.activeClassName);
	}
}

videojs.registerComponent('MulticamSwitchButton', SwitchButton);
